import React, { useEffect, useRef, useState } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormSelect,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-js-pagination";
import { Button } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { getAllDirector } from "src/redux/actions/customerAction";
import DirectorAddForm from "./operations/directorAddForm";
import DirectorListById from "./capital";
import { CSVLink } from "react-csv";
import {
  COMPANY_AddLogo,
  COMPANY_Address,
  COMPANY_NAME,
} from "src/services/const";

const DirectorList = () => {
  const componentPDF = useRef();
  const dispatch = useDispatch();

  const SchemaName = sessionStorage.getItem("schemaName");
  const { Directors, newDirectorCreated } = useSelector(
    (state) => state.customerReducer
  );

  const [pagination, setPagination] = useState({
    currentPage: 1,
    rowsPerPage: 10,
  });
  const [searchInput, setSearchInput] = useState("");
  const [view, setView] = useState({
    showAddForm: false,
    showAddButton: true,
    showSelectAndSearch: true,
    showEdit: false,
    directorData: false,
  });
  const [currItem, setCurrItem] = useState({});
  const [dataByDirectorId, setDataByDirectorId] = useState(null);
  const [printState, setPrintState] = useState(false);

  const handlePageChange = (pageNumber) =>
    setPagination((prev) => ({ ...prev, currentPage: pageNumber }));
  const handleRowsPerPageChange = (e) =>
    setPagination({ rowsPerPage: parseInt(e.target.value), currentPage: 1 });

  const handleShowAddForm = (details = {}) => {
    setView((prev) => ({ ...prev, showAddForm: true, showEdit: false }));
    setCurrItem(details);
  };

  const download_btn = () => setPrintState(true);

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const handleCapital = (data) => {
    setDataByDirectorId(data);
    setView((prev) => ({ ...prev, directorData: true }));
  };

  const filteredData = Directors?.data?.filter((item) =>
    item.directorName.toLowerCase().includes(searchInput.toLowerCase())
  );
  const indexOfLastRow = pagination.currentPage * pagination.rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - pagination.rowsPerPage;
  const currentRows = filteredData?.slice(indexOfFirstRow, indexOfLastRow);

  const modifiedRows =
    Directors?.data?.map(
      ({
        capitalAccounts,
        company,
        companyId,
        id,
        schemaName,
        interest,
        ...rest
      }) => rest
    ) ?? [];

  useEffect(() => {
    const obj = { schemaName: SchemaName };
    if (newDirectorCreated || !Directors?.data) {
      dispatch(getAllDirector(obj));
    }
  }, [newDirectorCreated, SchemaName, dispatch]);

  useEffect(() => {
    if (printState) generatePDF();
  }, [printState]);

  return (
    <CRow className="content">
      {view.directorData ? (
        <DirectorListById
          setDirectorData={(val) =>
            setView((prev) => ({ ...prev, directorData: val }))
          }
          dataByDirectorId={dataByDirectorId}
          directorData={view.directorData || false}
        />
      ) : (
        <CCol xs={12}>
          <CCard className="mb-4 custom-card">
            <CCardHeader className="custom-card-header">
              <h5>Directors</h5>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs={12}>
                  <CCard className="mb-2">
                    <div className="search_bar d-flex justify-content-between align-items-center  gap-2">
                      {view.showSelectAndSearch && (
                        <>
                          <CFormSelect
                            size="sm"
                            className="custom-form-input"
                            style={{ cursor: "pointer", maxWidth: "120px" }}
                            aria-label="Select"
                            onChange={handleRowsPerPageChange}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">50</option>
                            <option value="30">100</option>
                            <option value="30">200</option>
                          </CFormSelect>
                          <CFormInput
                            type="text"
                            size="sm"
                            placeholder="Search"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="custom-form-input"
                            style={{ minWidth: "250px" }}
                          />
                        </>
                      )}
                      {view.showAddButton && (
                        <div className="btn_add d-flex gap-2">
                          <Button
                            className="add-btn w-100"
                            style={{ whiteSpace: "nowrap" }}
                            onClick={() => handleShowAddForm()}
                          >
                            Add
                          </Button>
                          <Button
                            className="add-btn w-100"
                            style={{ whiteSpace: "nowrap" }}
                            onClick={download_btn}
                          >
                            Download
                          </Button>
                          <CSVLink
                            data={modifiedRows}
                            filename="director-table.csv"
                          >
                            <CButton
                              className="add-btn w-100"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              CSV
                            </CButton>
                          </CSVLink>
                        </div>
                      )}
                    </div>

                    <CCardBody>
                      <div
                        ref={printState ? componentPDF : null}
                        style={{ padding: printState ? "20px" : "0px" }}
                      >
                        {printState && (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              background:
                                "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                              padding: "20px",
                            }}
                          >
                            <img
                              src={COMPANY_AddLogo}
                              alt="Logo"
                              width="50px"
                              height="50px"
                            />
                            <p style={{ color: "#FFF" }}>Directors List</p>
                            <div style={{ textAlign: "start" }}>
                              <p
                                style={{
                                  fontWeight: "bold",
                                  color: "#FFF",
                                  fontSize: "20px",
                                }}
                              >
                                {COMPANY_NAME}
                              </p>
                              <p
                                style={{ color: "#FFF" }}
                              >{`(${COMPANY_Address})`}</p>
                            </div>
                          </div>
                        )}

                        <CTable className="custom-tablee" hover responsive>
                          <CTableHead>
                            <CTableRow>
                              <CTableHeaderCell>S. No.</CTableHeaderCell>
                              <CTableHeaderCell>Name</CTableHeaderCell>
                              <CTableHeaderCell>Email</CTableHeaderCell>
                              <CTableHeaderCell>Phone Number</CTableHeaderCell>
                              {!printState && (
                                <CTableHeaderCell>Actions</CTableHeaderCell>
                              )}
                            </CTableRow>
                          </CTableHead>
                          <CTableBody>
                            {currentRows?.map((datas, index) => (
                              <CTableRow key={index}>
                                <CTableDataCell>
                                  {indexOfFirstRow + index + 1}
                                </CTableDataCell>
                                <CTableDataCell>
                                  {datas.directorName || "--"}
                                </CTableDataCell>
                                <CTableDataCell>
                                  {datas.email || "--"}
                                </CTableDataCell>
                                <CTableDataCell>
                                  {datas.phoneNumber || "--"}
                                </CTableDataCell>
                                {!printState && (
                                  <CTableDataCell>
                                    <CButton
                                      className="btn"
                                      onClick={() => handleCapital(datas)}
                                    >
                                      Add Fund
                                    </CButton>
                                  </CTableDataCell>
                                )}
                              </CTableRow>
                            )) || (
                              <div className="loading_data">Loading...</div>
                            )}
                          </CTableBody>
                        </CTable>
                      </div>
                      <div className="pagin-div">
                        <div>
                          Showing {indexOfFirstRow + 1} to{" "}
                          {Math.min(indexOfLastRow, filteredData?.length)} of{" "}
                          {filteredData?.length} entries
                        </div>
                        <ReactPaginate
                          activePage={pagination.currentPage}
                          itemsCountPerPage={pagination.rowsPerPage}
                          totalItemsCount={filteredData?.length || 0}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          prevPageText="Previous"
                          nextPageText="Next"
                          firstPageText="First"
                          lastPageText="Last"
                          innerClass="pagination"
                          itemClass="page-item"
                          linkClass="page-link"
                        />
                      </div>
                      <CModal
                        visible={view.showAddForm}
                        onClose={() =>
                          setView((prev) => ({ ...prev, showAddForm: false }))
                        }
                        size="lg"
                      >
                        <CModalHeader className="custom-card-header">
                          <CModalTitle>Add Director</CModalTitle>
                        </CModalHeader>
                        <CModalBody>
                          <DirectorAddForm
                            selectedCompany={null}
                            setShowAddForm={(val) =>
                              setView((prev) => ({ ...prev, showAddForm: val }))
                            }
                            setShowAddButton={(val) =>
                              setView((prev) => ({
                                ...prev,
                                showAddButton: val,
                              }))
                            }
                            setShowSelectAndSearch={(val) =>
                              setView((prev) => ({
                                ...prev,
                                showSelectAndSearch: val,
                              }))
                            }
                            intial={currItem}
                            edit={view.showEdit}
                            callBack={() => window.location.reload()}
                          />
                        </CModalBody>
                      </CModal>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      )}
    </CRow>
  );
};

export default DirectorList;
